export * from './record-medical-inherited-family.interface';
export * from './medical-inherited-family-disease.interface';
export * from './medical-inherited-family.redux';

